import PageGallery from "../../../common/ts/components/PageGallery";

export class MiniSerpPagination {
    static readonly MINI_SERP_CONTAINER_SELECTOR = '.js-mini-serp-container';
    static readonly MINI_SERP_UNITS_CONTAINER_SELECTOR = '.js-mini-serp-units-container';

    private readonly miniSerpContainer: HTMLElement;
    private readonly miniSerpUnitsContainer: HTMLElement;
    private readonly onUnitsRefreshed: () => void;

    constructor(params: {
        miniSerpUnitsContainer: HTMLElement,
        onUnitsRefreshed?: () => void
    }) {
        this.onUnitsRefreshed = params.onUnitsRefreshed || (() => {
        });
        this.miniSerpUnitsContainer = params.miniSerpUnitsContainer;

        this.miniSerpContainer = document.querySelector(MiniSerpPagination.MINI_SERP_CONTAINER_SELECTOR) as HTMLElement;
    }

    init() {
        if (!this.miniSerpUnitsContainer) {
            return;
        }
        this.registerAjaxCallOnClickEvent();
    }

    private registerAjaxCallOnClickEvent() {
        this.miniSerpUnitsContainer.addEventListener('click', async (event: MouseEvent) => {
            const target = event.target as HTMLElement | null;
            if (!target || !(target instanceof HTMLElement)) {
                return;
            }
            const anchor = target.closest('.js-pagination a') as HTMLAnchorElement | null;
            if (!anchor) {
                return;
            }
            event.preventDefault();
            event.stopPropagation();

            const url = anchor.getAttribute('href') || anchor.href;
            if (!url) return;

            await this.callAjaxAndRefreshUnits(url);
        });
    }

    private async callAjaxAndRefreshUnits(url: string) {
        try {
            const response = await fetch(url, {
                method: 'GET',
                headers: {'Content-Type': 'text/html'},
                credentials: 'same-origin',
            });

            if (!response.ok) {
                return;
            }
            this.miniSerpUnitsContainer.innerHTML = await response.text();
            this.applyGallerySwiperOnRefreshedUnits();
            this.scrollToTopOfMiniSerpContainer();
            this.onUnitsRefreshed();
        } catch (e) {
        }
    }

    private applyGallerySwiperOnRefreshedUnits() {
        this.miniSerpUnitsContainer.querySelectorAll('.swiper-container:has(.swiper-wrapper)').forEach(el => {
            // @ts-ignore
            new PageGallery(el);
        });
    }

    private scrollToTopOfMiniSerpContainer() {
        if (this.miniSerpContainer instanceof HTMLElement) {
            this.miniSerpContainer.scrollIntoView({behavior: 'smooth', block: 'start'});
        }
    }
}
